import React from 'react';
import './InfoCard.scss';

function InfoCard({ title, items, notice }) {
  return (
    <div className="info-card">
      <h3 className="info-card__title">{title}</h3>
      {items && (
        <ul className="info-card__list">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      )}
      {notice && <p className="info-card__notice">{notice}</p>}
    </div>
  );
}

export default InfoCard; 